



































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
class ViewInfo {
  productName: string;
  sku: string;
  assetTypeName: string;
  conditionTypeName: string;
  type: string;
  fromDate: Date;
  toDate: Date;
  pagerequest: any;
}
class PagGeneralInventoryDetailRequest {
  warehouseCode: string;
  productId: number;
  type: string;
  assetTypeCode: string;
  conditionTypeCode: string;
  fromDate: Date;
  toDate: Date;
  pageSize: number;
  pageNumber: number;
}

@Component({
  components: {},
})
export default class GeneralInventoryDetail extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "generalInventoryReportDetail";
  viewInfo: ViewInfo = new ViewInfo();

  pagerequest: PagGeneralInventoryDetailRequest = new PagGeneralInventoryDetailRequest();

  get store() {
    return this.$store.state.generalInventoryReportDetail;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.viewInfo = this.$store.state.generalInventoryReport.viewInfo;
      this.pagerequest = this.viewInfo
        .pagerequest as PagGeneralInventoryDetailRequest;
      this.getpage();
    }
  }
  cancel() {
    this.$store.commit(`${this.namespace}/setCurrentPage`, 1);
    (this.$refs.detailForm as any).resetFields();
    this.$emit("input", false);
  }
  preGetPage() {
    this.pagerequest.pageSize = this.pageSize;
    this.pagerequest.pageNumber = this.currentPage;
  }
  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: `${this.namespace}/exportDetail`,
      data: this.pagerequest,
    });
  }
  outboundColumns() {
    return this.viewInfo.type == "INBOUND"
      ? []
      : [
          {
            title: Util.L("CustomerCode"),
            key: "customerCode",
          },
          {
            title: Util.L("CustomerName"),
            key: "customerName",
          },
        ];
  }
  aoGroupColumns() {
    return this.viewInfo.type == "INBOUND"
      ? []
      : [
          {
            title: Util.L("AOGroupCode"),
            key: "aoGroupCode",
            width: 120,
          },
        ];
  }
  ActionColumns() {
    return this.viewInfo.type == "INBOUND"
      ? [
          {
            title: Util.L("Action"),
            key: "actionTypeName",
            width: 120,
          },
        ]
      : [
          {
            title: Util.L("Action"),
            key: "actionTypeName",
            width: 120,
          },
        ];
  }

  get columns() {
    return [
      {
        title: Util.L("Order"),
        width: 50,
        key: "orderNo",
      },
      {
        title:
          this.viewInfo.type == "INBOUND"
            ? Util.L("InboundDate")
            : Util.L("OutboundDate"),
        key: "transDate",
        width: 170,
        render: (h, params) => {
          if (Util.isNull(params.row.transDate)) return "";
          return h("span", Util.toLocalViewDateString(params.row.transDate));
        },
      },
      {
        title: Util.L("ObjectCode"),
        slot: "objectCode",
        width: 140,
      },
      {
        title: Util.L("ExternalCode"),
        key: "objectExternalCode",
        width: 140,
      },
      ...this.ActionColumns(),
      ...this.aoGroupColumns(),
      {
        title: Util.L("Qty"),
        key: "qty",
        align: "right",
        render: (h, params) => {
          return h("span", Util.toViewNumberString(params.row.qty));
        },
      },
      ...this.outboundColumns(),
    ];
  }
}
